import InformedConsent from "./InformedConsent";

export default InformedConsent;